import React from 'react'
import styled from 'styled-components'
import MarkdownRender from 'components/Luxkit/MarkdownRender'
import List from 'components/Common/List'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Group from 'components/utils/Group'

const StyledList = styled(List)`
  margin-top: 0;
`

interface Props {
  finePrint: App.BedbankPropertyFinePrint
}

function PropertyFinePrint({
  finePrint,
}:Props) {
  return <Group gap={20} direction="vertical">
    {(finePrint.checkIn?.beginTime || finePrint.checkIn?.endTime) &&
      <div>
        <BodyText variant="medium" as="h4" weight="bold">Check-in</BodyText>
        {finePrint.checkIn.beginTime && <BodyText variant="medium">Check-in starts at {finePrint.checkIn.beginTime}</BodyText>}
        {finePrint.checkIn.endTime && <BodyText variant="medium">Check-in ends at {finePrint.checkIn.endTime}</BodyText>}
      </div>
    }
    {finePrint.checkOut?.time &&
      <div>
        <BodyText variant="medium" as="h4" weight="bold">Check-out</BodyText>
        <BodyText variant="medium">Check-out before {finePrint.checkOut.time}</BodyText>
      </div>
    }
    {(finePrint.checkIn?.specialInstructions || finePrint.checkIn?.instructions) &&
      <div>
        <BodyText variant="medium" as="h4" weight="bold">Special check-in instructions</BodyText>
        {finePrint.checkIn.specialInstructions && <BodyText variant="medium">{finePrint.checkIn.specialInstructions}</BodyText>}
        {finePrint.checkIn.instructions && <BodyText variant="medium" as="p">{finePrint.checkIn.instructions}</BodyText>}
      </div>
    }
    {finePrint.pets?.length &&
      <div>
        <BodyText variant="medium" as="h4" weight="bold">Pets</BodyText>
        <StyledList spaced>
          {finePrint.pets.map(item => <BodyText variant="medium" as="li" key={item}>{item}</BodyText>)}
        </StyledList>
      </div>
    }
    {(finePrint.fees?.optional || finePrint.fees?.mandatory) &&
      <div>
        <BodyText variant="medium" as="h4" weight="bold">Fees</BodyText>
        {finePrint.fees.mandatory && <MarkdownRender type="compact" fontSize="medium" content={finePrint.fees.mandatory} />}
        {finePrint.fees.optional && <MarkdownRender type="compact" fontSize="medium" content={finePrint.fees.optional} />}
      </div>
    }
    {finePrint.policies?.knowBeforeYouGo &&
      <div>
        <BodyText variant="medium" as="h4" weight="bold">Know Before You Go</BodyText>
        <MarkdownRender type="compact" fontSize="medium" content={finePrint.policies.knowBeforeYouGo} />
      </div>
    }
  </Group>
}

export default React.memo(PropertyFinePrint)
